<div >
  <h4 class="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="onCloseClick.emit()"
  >
  <nb-icon icon="close"></nb-icon>
  </button>
</div>
